// dependencies
import * as d3 from "d3";

const generateGraph = (svgContainer, data) => {
	// clear the graph ( if one exists )
	d3.select(svgContainer).select("svg").remove();

	const margin = { top: 10, right: 0, bottom: 150, left: 30 };
	const height = 600 - margin.top - margin.bottom;
	const width = svgContainer.offsetWidth - margin.left - margin.right;

	const svg = d3
		.select(svgContainer)
		.append("div")
		.attr("class", "barchart-container")
		.append("svg")
		.attr("width", width + margin.left + margin.right)
		.attr("height", height + margin.top + margin.bottom);

	const g = svg.append("g").attr("transform", `translate(${margin.left},${margin.top})`);

	const xScale = d3.scaleBand().rangeRound([0, width]).padding(0.2);
	const yScale = d3.scaleLinear().rangeRound([height, 0]);

	const yMax = d3.max(data, (d) => d.count);

	xScale.domain(data.map((d) => d.company.name));
	yScale.domain([0, yMax]);

	const z = d3.scaleOrdinal(d3.schemeCategory10);

	const yAxis = d3
		.axisLeft(yScale)
		.tickValues([0, yMax * 0.5, yMax])
		.tickSize(-width, 0, 0);

	g.append("g").classed("y axis", true).call(yAxis);

	const xAxis = d3.axisBottom(xScale).tickFormat((d) => d);

	g.append("g")
		.classed("x axis", true)
		.attr("transform", `translate(0, ${height})`)
		.call(xAxis)
		.selectAll("text")
		.attr("y", 12)
		.attr("x", 1)
		.attr("dy", ".35em")
		.attr("transform", "rotate(15)")
		.style("text-anchor", "start");

	g.selectAll(".bar")
		.data(data)
		.enter()
		.append("a")
		.attr("xlink:href", (d) => `/companies/${d.company.id}/`)
		.attr("class", "bar")
		.append("rect")
		.attr("class", "actual-bar")
		.attr("x", (d) => xScale(d.company.name))
		.attr("y", (d) => yScale(d.count))
		.attr("width", xScale.bandwidth())
		.attr("height", (d) => height - yScale(d.count))
		.style("fill", (d, ii) => z(ii));
};

export default generateGraph;
